import React from 'react';
import {useSelector} from 'react-redux';
import userService from '../../../../services/user/UserService';
import MessageAutoTieView from './MessageAutoTieView';

function MessageAutoTieContainer() {
  const organisation = useSelector(state => state.organisation);
  const [domainName, setDomainName] = React.useState('');

  React.useEffect(() => {
    userService.getAcceptationDomainNameAutomaticTieUser(organisation.organisationId)
      .then(domainNames => {
        const listDomain = domainNames.map(domain => `"${domain.domainName}"`);
        setDomainName([...new Set(listDomain)].join(', '));
      });
  }, [organisation.organisationId]);

  return (
    <MessageAutoTieView domainName={domainName}/>
  );
}

export default MessageAutoTieContainer;
